"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoleResponseDto = void 0;
const mappable_base_1 = require("../../mappable.base");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const enums_1 = require("../../enums");
class RoleResponseDto extends mappable_base_1.MappableBase {
    constructor(roleOptions) {
        super();
        if (!roleOptions)
            return;
        Object.assign(this, roleOptions);
    }
    getFields() {
        return [
            'id',
            'name',
            'privileges',
            'schoolId',
            'school_name',
            'userType',
            'behaviorCodeTypes'
        ];
    }
    id;
    name;
    school_name;
    privileges;
    schoolId;
    userType;
    behaviorCodeTypes;
    static mapRoles(entities) {
        return mappable_base_1.MappableBase.mapAll(entities, RoleResponseDto);
    }
}
exports.RoleResponseDto = RoleResponseDto;
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsPositive)(),
    __metadata("design:type", Number)
], RoleResponseDto.prototype, "id", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], RoleResponseDto.prototype, "name", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], RoleResponseDto.prototype, "school_name", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsArray)(),
    __metadata("design:type", Array)
], RoleResponseDto.prototype, "privileges", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsPositive)(),
    __metadata("design:type", Number)
], RoleResponseDto.prototype, "schoolId", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(enums_1.UserTypeEnum),
    __metadata("design:type", String)
], RoleResponseDto.prototype, "userType", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], RoleResponseDto.prototype, "behaviorCodeTypes", void 0);
